var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00244141H513V341.99H0V-0.00244141Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.286 171L0 315.186V26.8018L216.286 171ZM513 26.8018V315.186L296.714 171L513 26.8018Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 26.802L296.714 171L513 315.186V341.995H472.797L256.5 197.798L40.2034 341.995H0V315.186L216.286 171L0 26.802V-0.00830078H40.2034L256.5 144.19L472.797 -0.00830078H513V26.802Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 26.802L296.714 171L513 315.186V341.995H472.797L256.5 197.798L40.2034 341.995H0V315.186L216.286 171L0 26.802V-0.00830078H40.2034L256.5 144.19L472.797 -0.00830078H513V26.802Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00634766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJm);
export default __webpack_public_path__ + "static/media/JM.f188d93ffe01a819af6343930ae971d0.svg";
export { ForwardRef as ReactComponent };